import { Logging } from '#common/logging';
import { EventCursorExpiredError, EventSchemaUnsupportedError, EventStreamUnsupportedError, InvalidArgumentError, WebFsError, } from '#common/types';
import { Synchronized } from '#common/util';
import { parseWasmResult } from '#wasm/common';
const CURSOR_REJECTION_MARKER = 'restart from GetEventsTail';
const FEATURE_ABSENT_MARKER = 'stored procedure does not exist';
const SCHEMA_UNSUPPORTED_MARKER = 'unsupported event schema version';
function classifyEventStreamRejection(error) {
    if (error instanceof WebFsError &&
        !(error instanceof EventStreamUnsupportedError) &&
        error.message.toLowerCase().includes(FEATURE_ABSENT_MARKER)) {
        throw new EventStreamUnsupportedError(error.message, error.devDetails);
    }
    if (error instanceof WebFsError &&
        !(error instanceof EventSchemaUnsupportedError) &&
        error.message.toLowerCase().includes(SCHEMA_UNSUPPORTED_MARKER)) {
        throw new EventSchemaUnsupportedError(error.message, error.devDetails);
    }
    if (error instanceof InvalidArgumentError) {
        const isAlreadyClassified = error instanceof EventCursorExpiredError;
        const isCursorRejection = !isAlreadyClassified && error.message.includes(CURSOR_REJECTION_MARKER);
        if (isCursorRejection) {
            throw new EventCursorExpiredError(error.message, error.devDetails);
        }
    }
    throw error;
}
export class EventsWasm extends Synchronized {
    modAsync;
    logger = Logging.getLogger('WASM.Events');
    constructor(modAsync, mutex) {
        super(mutex);
        this.modAsync = modAsync;
    }
    async listEventsPaginated(limit, cursor) {
        const result = await this.mutex
            .runExclusive(async () => {
            return parseWasmResult(await this.modAsync.ListEventsPaginated(limit, cursor));
        })
            .catch(classifyEventStreamRejection);
        this.logger.debug({ limit, hasCursor: Boolean(cursor), eventCount: result.events.length }, 'ListEventsPaginated');
        return result;
    }
    async tailCursor() {
        const result = await this.mutex
            .runExclusive(async () => {
            return parseWasmResult(await this.modAsync.EventsTailCursor());
        })
            .catch(classifyEventStreamRejection);
        this.logger.debug({ hasCursor: Boolean(result.cursor) }, 'EventsTailCursor');
        return result;
    }
}
